import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-600d733c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "following__item" }
const _hoisted_2 = { class: "username-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_User = _resolveComponent("User")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_User, {
      username: $props.username,
      avatarUrl: $props.avatarUrl,
      vClass: "following"
    }, {
      desc: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, _toDisplayString($props.userType), 1)
      ]),
      _: 1
    }, 8, ["username", "avatarUrl"]),
    _createVNode(_component_Button, {
      text: 'following',
      size: 'small',
      onClick: _cache[0] || (_cache[0] = 
        () => {
          _ctx.$emit('unfollow');
          $data.loading = true;
        }
      ),
      loading: $data.loading
    }, null, 8, ["loading"])
  ]))
}